export const parseList = (v) => {
  if (Array.isArray(v)) return v;
  if (typeof v === "string" && v.trim().startsWith("[")) {
    try { return JSON.parse(v); } catch { return []; }
  }
  return [];
};

export const parseObj = (v) => {
  if (v && typeof v === "object") return v;
  try { return JSON.parse(v); } catch { return null; }
};

export const fullName = (u) => (u ? [u.first_name, u.last_name].filter(Boolean).join(" ") || u.email || "—" : "—");

export const fmtAgeMonths = (m) => (m == null ? "—" : m < 24 ? `${m} mois` : `${Math.floor(m / 12)} ans`);

export const cleanMd = (s) => (s || "").replace(/\*\*/g, "");

export const COLLECTION_LABELS = {
  users: "Utilisateurs", doctor_profiles: "Profils médecins", patients: "Enfants", growth_metrics: "Mesures de croissance",
  vaccinations: "Vaccinations", consultations: "Consultations", prescriptions: "Ordonnances", appointments: "Rendez-vous",
  access_grants: "Accès au dossier", symptom_submissions: "Bilans de symptômes", drugs: "Médicaments",
  pathologies: "Pathologies", epi_cases: "Cas épidémiologiques", medical_facilities: "Établissements",
  med_documents: "Documents médicaux", lab_results: "Analyses biologiques", imaging_exams: "Examens d'imagerie",
  directory: "Annuaire",
};
